import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductUsage, ProductUsageDataService } from '@vi-succ/products-domain';
import { Observable, map } from 'rxjs';
import { UsageItem } from '../entity';
import { environment } from '../environments/environment';
import { ProductUsageFactory } from '../factories/product-usage.factory';

@Injectable({
  providedIn: 'root',
})
export class EtProductUsageDataService implements ProductUsageDataService {
  constructor(private http: HttpClient) {}

  getProductUsage(
    salesOrg: string,
    language: string,
    materialNumber: string,
    query?: string
  ): Observable<ProductUsage> {
    const headers: HttpHeaders = new HttpHeaders().set('X-API-KEY', environment.backend.apiKey);

    const params: { [key: string]: string } = {};
    if (query) {
      params['query'] = query;
    }

    return this.http
      .get<UsageItem[]>(environment.backend.url + `/product/${salesOrg}/${language}/${materialNumber}/usage`, {
        headers,
        params,
      })
      .pipe(map((usages) => ProductUsageFactory.build(usages, materialNumber)));
  }
}
